export default __webpack_public_path__ + "static/media/daylight-transport.df0f91fc.png";